import React, { ChangeEvent } from 'react';
import { TableDataCase } from '../TableDataCase';
import { ControlledCommande } from '../../../../../types/commande/commande.def';
import { Checkbox } from '../../../../atoms/Inputs/Checkbox';
import {
  formatCommandStatus,
  formatCommandMethodePaiement
} from 'helpers/commande/formatCommand';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import { useToCommandePages } from 'hooks/useToCommandePages';

export const TableDataLineControl = ({
  user,
  commande,
  onChange
}: {
  user: string;
  commande: ControlledCommande;
  onChange: (e: ChangeEvent) => void;
}) => {
  const [toCommandeUpdatePage] = useToCommandePages();
  return (
    <tr>
      <TableDataCase variant={'data'} data={user} />
      <TableDataCase variant={'data'} data={commande.numerocommande} />
      <TableDataCase
        variant={'data'}
        data={commande.client.prenom + ' ' + commande.client.nom}
      />
      <TableDataCase variant={'data'} data={commande.prixTotal + ' €'} />
      <TableDataCase
        variant={'data'}
        data={formatCommandMethodePaiement(commande.methodepaiement)}
      />
      <TableDataCase
        variant={'data'}
        color={commande?.customerContributedToTheOng ? 'green' : 'red'}
        data={commande?.customerContributedToTheOng ? 'Oui' : 'Non'}
      />
      <TableDataCase
        variant={'data'}
        data={formatCommandStatus(commande.status)}
      />
      <TableDataCase
        variant={'data'}
        data={
          <ButtonWithText
            variant="mobileTab"
            onClick={() => toCommandeUpdatePage(String(commande.id))}
            icon={'Edit'}
            content=""
          />
        }
      />
      <TableDataCase
        variant={'data'}
        data={
          <Checkbox
            onChange={onChange}
            value={commande.id}
            initialValue={commande.controlled}
            color="white"
          />
        }
        color={commande.controlled ? 'green' : 'red'}
      />
    </tr>
  );
};
